export { default } from './FeaturedProducts'
